import { User } from "../@core/data/users";
import { EnrollmentLecture, EnrollmentSection } from "./enrollment.model";

export default class CourseSection {
  id?: string;
  courseId?: string;
  title?: string;
  positionOrd?: number;
  status?: number;

  noLecture?: number;
  lectures?: SectionLecture[];

  linkExerciseId?: string;
  linkExerciseTitle?: string;

  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;

  //Using student/course
  enrolSection?: EnrollmentSection;
  enrolLectures?: EnrollmentLecture[];
}

export class SectionLecture {
  id?: string;
  courseId?: string;
  sectionId?: string;
  title?: string;
  status?: number;
  privacy?: boolean;
  sourceType?: string; //video/images/document/live
  lectureContentId?: string;
  linkExerciseId?: string;
  linkExerciseTitle?: string;

  positionOrd?: number;
  //Using student/course ( not save in db)
  enrolLecture?: EnrollmentLecture;
}

export class CourseSectionLecture {
  id?: string;
  courseId?: string;
  sectionId?: string;
  title?: string;
  positionOrd?: number;
  status?: number;
  privacy?: boolean;

  sourceType?: string; //video/images/document/live
  lectureContentId?: string;

  linkExerciseId?: string;
  linkExerciseTitle?: string;

  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;

  //Using student/course
  enrolLecture?: EnrollmentLecture;
}
